import * as React from 'react';
import AccountsByFundGroupCore from '../FundGroupOrientation/AccountsByFundGroupCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';

const AccountsByGovernmentalA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AccountsByFundGroupCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser}
                fundGroup="Governmental"
                noData="workState_noGovernmentalFunds"
                done="workState_governmentalFundsComplete"
                reviewed="reviewState_governmentalFundsReviewed"
            />
        </React.Fragment>
    );
}

export default AccountsByGovernmentalA;